<template>
  <base-stat-item :metric="metric" label="Enquiry Via Email">
    <template v-slot:icon>
      <email-enquiry-icon></email-enquiry-icon>
    </template>
  </base-stat-item>
</template>
<script>
import BaseStatItem from './BaseStatItem.vue';
import EmailEnquiryIcon from '../Icons/EmailEnquiryIcon.vue';

export default {
  props: {
    metric: [String, Number],
  },
  components: {
    BaseStatItem,
    EmailEnquiryIcon,
  },
};
</script>
